import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IpeBrandMark } from '@/components/ipe/IpeBrandLogo';
import IpeWorkbenchUserProfile from '@/components/ipe/IpeWorkbenchUserProfile';
import { useIpeAuth } from '@/context/IpeAuthContext';
import IpeLocaleSwitcher from '@/i18n/IpeLocaleSwitcher';
import IpeWorkspaceSwitcher from './IpeWorkspaceSwitcher';
import WorkbenchNotificationCenter from './WorkbenchNotificationCenter';
import { useWorkspaceSwitchLocked } from '@/pages/ipe/workbench/hooks/useWorkspaceSwitchLock';
import { buildWorkbenchNavUrl, WORKBENCH_HOME_NAV_ID } from '@/pages/ipe/workbench/constants/workbenchNavConfig';
import {
  navigateDetailToOrderCenter,
  navigateDetailToTeamManagement,
} from '@/pages/ipe/workbench/utils/detailPageNavigate';

export default function WorkbenchHeaderBar({
  onOpenAccountCenter,
  onOpenOpenKeys,
  showToast,
  disableWorkspaceSwitch = false,
  workspaceSwitchDisabledReason,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, user, goToLoginPage, logout } = useIpeAuth();
  const workspaceSwitchLocked = useWorkspaceSwitchLocked();
  const openTeamManagement = useCallback(() => {
    navigateDetailToTeamManagement(navigate);
  }, [navigate]);
  const openOrderCenter = useCallback(() => {
    navigateDetailToOrderCenter(navigate);
  }, [navigate]);
  const switchDisabled = disableWorkspaceSwitch || workspaceSwitchLocked;
  const switchDisabledReason = workspaceSwitchDisabledReason
    || (workspaceSwitchLocked ? t('workflowSwitchLocked') : undefined)
    || (disableWorkspaceSwitch ? t('workspaceSwitchLocked') : undefined);

  return (
    <>
      <div className="funding-workbench-top-bar">
        <div className="funding-workbench-top-bar__start">
          <IpeBrandMark
            className="funding-workbench-top-bar__brand-mark"
            textClassName="funding-workbench-top-bar__brand-name"
            text="IPE"
            logoSize={32}
            to={buildWorkbenchNavUrl(WORKBENCH_HOME_NAV_ID)}
          />
        </div>

        <div className="funding-workbench-top-bar__spacer" aria-hidden="true" />

        <div className="funding-workbench-top-bar__end">
          <span data-ipe-locale-dock="">
            <IpeLocaleSwitcher />
          </span>
          {isAuthenticated ? (
            <>
              <IpeWorkspaceSwitcher
                showToast={showToast}
                disabled={switchDisabled}
                disabledTitle={switchDisabledReason}
              />
              <WorkbenchNotificationCenter />
              <IpeWorkbenchUserProfile
                user={user}
                onLogout={logout}
                onOpenAccountCenter={onOpenAccountCenter}
                onOpenTeamManagement={openTeamManagement}
                onOpenOrderCenter={openOrderCenter}
                onOpenOpenKeys={onOpenOpenKeys}
                showToast={showToast}
                variant="chip"
              />
            </>
          ) : (
            <button
              type="button"
              className="funding-workbench__header-auth-btn funding-workbench__header-auth-btn--primary"
              onClick={goToLoginPage}
            >
              {t('login')}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
